import { LocalStorage } from 'src/utils/LocalStorage';
import { CartModel } from './models';

/**
 * ID for cart data to store to LocalStorage
 * Please update the version whenever the data structure is changed.
 * If you don't then the app will be broken when user's browser saves the previous structure.
 */
export const CART_LOCAL_STORAGE_KEY = 'cart-v0';

/**
 * Get cart data from LocalStorage
 * @returns cart model data
 */
export const getCartDataFromLocalStorage = (): CartModel | undefined => {
  return LocalStorage.tryGetJSONItem(CART_LOCAL_STORAGE_KEY) as CartModel;
};

/**
 * Set cart data to LocalStorage without isLoading as it is unnecessary
 * @param initialCartData cart data
 */
export const setCartDataToLocalStorage = ({ isLoading, ...cartData }: CartModel) => {
  LocalStorage.trySetJSONItem(CART_LOCAL_STORAGE_KEY, cartData);
};
